<template>
  <b-container fluid>
    <div class="p-3">
      <b-row>
        <b-col
          :cols="formItem === null ? 12 : 2"
          :class="{
            'd-none': formItem !== null,
            'd-md-block': formItem !== null,
          }"
        >
          <b-row class="mb-3">
            <b-col>
              <h5>Chart Reports</h5>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col>
              <b-button variant="primary" size="sm" @click="addChartReport"
                >Add Chart Report
              </b-button>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col>
              <b-list-group>
                <b-list-group-item
                  class="clickable"
                  v-for="item in chartReports"
                  :key="item.id"
                  @click="loadChartReport(item)"
                >
                  <b-row>
                    <b-col cols="12">
                      <span>
                        {{ item.dashboardName }}
                      </span>
                    </b-col>
                    <b-col>
                      <small class="mr-3 text-muted">
                        Owner: {{ item.createdBy }}
                      </small>
                    </b-col>
                  </b-row>
                </b-list-group-item>
              </b-list-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col v-if="formItem !== null">
          <chart-report-builder
            :chartReport="formItem"
            :datasets="datasets"
            @exitBuilder="formItem = null"
            @submitChartReport="submitChartReport"
            @deleteChartReport="deleteChartReport"
          ></chart-report-builder>
          <!--          <b-card>-->
          <!--            <template #header>-->
          <!--              <b-icon-x-->
          <!--                class="clickable float-right"-->
          <!--                @click="formItem = null"-->
          <!--              />-->
          <!--            </template>-->
          <!--            <b-row class="mb-3">-->
          <!--              <b-col>-->
          <!--                <chart-report-builder-->
          <!--                  :chartReport="formItem"-->
          <!--                  :datasets="datasets"-->
          <!--                  @submitChartReport="submitChartReport"-->
          <!--                  @deleteChartReport="deleteChartReport"-->
          <!--                ></chart-report-builder>-->
          <!--              </b-col>-->
          <!--            </b-row>-->
          <!--          </b-card>-->
        </b-col>
      </b-row>
      <div v-if="formItem === null"></div>
      <div v-else></div>
    </div>
  </b-container>
</template>

<script>
/*global _*/
import application from '@/mixins/application';
import ChartReportBuilder from '@/components/charts/ChartReportBuilder';
// import Chart from "chart.js";

const defaultFormItem = {
  id: null,
  isPrivate: false,
  dashboardName: '',
  charts: [],
};

export default {
  name: 'ChartsReport',
  mixins: [application],
  components: {
    ChartReportBuilder,
  },
  data() {
    return {
      chartReports: [],
      formItem: null,
      datasets: [],
    };
  },
  mounted() {
    this.getList();
    this.getDatasets();
  },
  methods: {
    getList() {
      const vm = this;
      return vm.axios.get('/api/reportDashboards').then(resp => {
        vm.chartReports = resp.data;
      });
    },
    getDatasets() {
      const vm = this;
      return vm.axios.get('/api/datasets').then(resp => {
        vm.datasets = resp.data;
      });
    },
    addChartReport() {
      this.formItem = _.cloneDeep(defaultFormItem);
    },
    loadChartReport(item) {
      const formItem = _.cloneDeep(item);
      //sort them by index
      formItem.charts = _.sortBy(formItem.charts, chart => {
        return chart.index ?? 0;
      });
      //if width is missing, add the default value of 6
      _.each(formItem.charts, chart => {
        if (!chart.width) {
          chart.width = 6;
        }
      });
      this.formItem = formItem;
    },
    submitChartReport(chartReport) {
      const vm = this;
      for (let i = 0; i < chartReport.charts.length; i++) {
        chartReport.charts[i].index = i;
      }
      if (chartReport.id === null) {
        delete chartReport.id;
        vm.axios
          .post('/api/reportdashboards/', chartReport)
          .then(() => {
            vm.formItem = null;
            vm.getList();
            vm.PromptSuccess(
              'Success',
              'Report had been created successfully.'
            );
          })
          .catch(() => {
            vm.PromptWarning(
              'Failed',
              'Failed to create Report. Please try again.'
            );
          });
      } else {
        vm.axios
          .put('/api/reportdashboards/' + chartReport.id, chartReport)
          .then(() => {
            vm.formItem = null;
            vm.getList();
            vm.PromptSuccess(
              'Success',
              'Report had been updated successfully.'
            );
          })
          .catch(() => {
            vm.PromptWarning(
              'Failed',
              'Failed to update Report. Please try again.'
            );
          });
      }
    },
    deleteChartReport(id) {
      const vm = this;
      vm.axios
        .delete('/api/reportdashboards/' + id)
        .then(() => {
          vm.formItem = null;
          this.getList();
          vm.PromptSuccess('Success', 'Report had been deleted successfully.');
        })
        .catch(() => {
          vm.PromptWarning(
            'Failed',
            'Failed to delete Report. Please try again.'
          );
        });
    },
  },
};
</script>